/* eslint-disable prettier/prettier */
import axios from 'axios'
import moment from 'moment'

const state = {
    salesQuotes: {},
    salesQuote: {},
    salesQuoteForEmailToClient: {},
    isLoadingTable: false,
    showDeleteModal: false,
    showEmailToClientModal: false,
}

const mutations = {
    getPaginatedSalesQuotes(state, payload) {
        state.isLoadingTable = true
        axios.get(`api/salesquotes/page=${payload.page}&pageSize=${payload.pageSize}/${payload.query}`).then(response => {
            response.data.data.forEach(sq=>{
                sq.dateCreated = moment(sq.dateCreated).format('MM/DD/YYYY HH:mm')
            })
            state.salesQuotes = response.data
            // eslint-disable-next-line no-console
        }).catch(error => console.log(error)).then(() => state.isLoadingTable = false)
    },
    openDeleteModal(state, payload) {
        state.showDeleteModal = payload.showDeleteModal
        if (payload.salesQuote) {
            state.salesQuote = payload.salesQuote
        } else {
            state.salesQuote = {}
        }
    },
    openEmailToClientModal(state, payload) {
        state.showEmailToClientModal = payload.showEmailToClientModal
        if (payload.salesQuoteForEmailToClient) {
            state.salesQuoteForEmailToClient = payload.salesQuoteForEmailToClient
        } else {
            state.salesQuoteForEmailToClient = {}
        }
    }
}

const actions = {
    getPaginatedSalesQuotes({
        commit
    }, payload) {
        commit('getPaginatedSalesQuotes', payload)
    },
    openDeleteModal({
        commit
    }, payload) {
        commit('openDeleteModal', payload)
    },
    openEmailToClientModal({
        commit
    }, payload) {
        commit('openEmailToClientModal', payload)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}